var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconProfileSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 5.16667C10.6663 5.87391 10.3854 6.55219 9.88529 7.05229C9.3852 7.55238 8.70692 7.83333 7.99967 7.83333C7.29243 7.83333 6.61415 7.55238 6.11406 7.05229C5.61396 6.55219 5.33301 5.87391 5.33301 5.16667C5.33301 4.45942 5.61396 3.78115 6.11406 3.28105C6.61415 2.78095 7.29243 2.5 7.99967 2.5C8.70692 2.5 9.3852 2.78095 9.88529 3.28105C10.3854 3.78115 10.6663 4.45942 10.6663 5.16667ZM7.99967 9.83333C6.762 9.83333 5.57501 10.325 4.69984 11.2002C3.82467 12.0753 3.33301 13.2623 3.33301 14.5H12.6663C12.6663 13.2623 12.1747 12.0753 11.2995 11.2002C10.4243 10.325 9.23735 9.83333 7.99967 9.83333Z",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconProfileSmall);
export default __webpack_public_path__ + "static/media/common_icon_profile_small.12911902d6da8e102f574808a59fd13f.svg";
export { ForwardRef as ReactComponent };